import { FaCheck } from "react-icons/fa6";
import ThemeMaker from "../../components/thememaker";

const steps = [
    { id: 1, label: "Business Details" },
    { id: 2, label: "Basic Details" },
    { id: 3, label: "Bank Details" },
    { id: 4, label: "KYC Verification" },
];

export default function ProgressBar({ currentStep = 1 }) {
    return (
        <>
        {/* <ThemeMaker /> */}
        <div className="d-flex justify-content-center align-items-center py-4 pb-0 px-2 flex-wrap">
            {steps.map((step, index) => {
                const isCompleted = step.id < currentStep;
                const isActive = step.id === currentStep;
                const isLast = index === steps.length - 1;

                return (
                    <div key={step.id} className="d-flex align-items-center">

                        <div className="d-flex flex-column align-items-center text-center">

                            <div
                                className={`progress-circle d-flex justify-content-center align-items-center fw-semibold
                  ${isCompleted ? "completed" : ""}
                  ${isActive ? "active" : ""}
                `}
                            >
                                {isCompleted ? (
                                    <FaCheck size={16} strokeWidth={3} />
                                ) : (
                                    <span
                                        className={`inner-dot ${isActive ? "bg-orange" : "bg-secondary"}`}
                                    ></span>
                                )}
                            </div>

                            <span
                                className={`mt-2 small fw-medium 
                  ${isCompleted || isActive ? "text-dark" : "text-muted"}
                `}
                            >
                                {step.label}
                            </span>
                        </div>

                        {!isLast && (
                            <div className="mx-2 mb-4">
                                <div
                                    className={`connector-line ${isCompleted ? "completed-line" : ""
                                        }`}
                                ></div>
                            </div>
                        )}
                    </div>
                );
            })}
        </div>
        </>
    );
}